/* FOLLIVA INSTRUMENT — cart engine: drawer + AJAX add/change/discount + Section Rendering */
(function () {
  "use strict";
  var FL = window.FL || (window.FL = {});

  function drawer() { return document.querySelector("[data-fl-cart-drawer]"); }
  function panel() { var d = drawer(); return d && d.querySelector(".fl-drawer__panel"); }
  var releaseTrap = null;

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.add("is-open"); d.setAttribute("aria-hidden", "false");
    if (FL.lockScroll) FL.lockScroll(true);
    if (FL.trapFocus) { if (releaseTrap) releaseTrap(); releaseTrap = FL.trapFocus(panel() || d, { onEscape: closeDrawer, autofocus: false }); }
    FL.emit && FL.emit("fl:drawer:open");
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true");
    if (FL.lockScroll) FL.lockScroll(false);
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    FL.emit && FL.emit("fl:drawer:close");
  }
  function setLoading(on) { var d = drawer(); if (d) d.classList.toggle("is-loading", !!on); }

  /* ---- Section rendering swap ---- */
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var doc = new DOMParser().parseFromString(sections[id], "text/html");
      var fresh = doc.querySelector("[data-fl-cart-section]");
      var live = document.querySelector("[data-fl-cart-section]");
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    });
    var freshCount = document.querySelector("[data-fl-cart-section] [data-fl-cart-count]");
    updateHeaderCount(freshCount ? parseInt(freshCount.textContent, 10) : null);
  }
  function updateHeaderCount(n) {
    document.querySelectorAll(".fl-header__cart-count[data-fl-cart-count]").forEach(function (el) {
      if (n == null) return;
      el.textContent = n;
      if (n > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
  }

  /* ---- CartStore (single-flight queue) ---- */
  var queue = Promise.resolve();
  function sectionsBody() { return { sections: FL.cartSectionIds ? FL.cartSectionIds() : [], sections_url: window.location.pathname }; }
  function mutate(url, body) {
    return (queue = queue.then(function () {
      setLoading(true);
      return FL.fetchJSON(url, { method: "POST", body: Object.assign(body, sectionsBody()) })
        .then(function (res) {
          applySections(res.sections);
          FL.emit && FL.emit("fl:cart:updated", { source: url });
          return res;
        })
        .catch(function (err) {
          FL.emit && FL.emit("fl:cart:error", { message: err.message });
          throw err;
        })
        .finally(function () { setLoading(false); });
    }));
  }
  var Cart = FL.cart = {
    add: function (items) { return mutate(FL.routes.cartAdd + ".js", { items: items }).then(function (r) { openDrawer(); return r; }); },
    change: function (key, qty) { return mutate(FL.routes.cartChange + ".js", { id: key, quantity: qty }); },
    updateDiscount: function (code) { return mutate(FL.routes.cartUpdate + ".js", { discount: code }); }
  };

  /* ---- Delegated events ---- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-fl-cart-toggle]");
    if (toggle) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest("[data-fl-cart-close]")) { e.preventDefault(); closeDrawer(); return; }

    var up = e.target.closest("[data-fl-qty-up]"), down = e.target.closest("[data-fl-qty-down]");
    if (up || down) {
      var wrap = (up || down).closest("[data-fl-qty]"); var inp = wrap && wrap.querySelector("[data-fl-qty-input]");
      if (inp) { var q = Math.max(0, (parseInt(inp.value, 10) || 0) + (up ? 1 : -1)); Cart.change(inp.getAttribute("data-key"), q); }
      return;
    }
    var rm = e.target.closest("[data-fl-remove]");
    if (rm) { e.preventDefault(); Cart.change(rm.getAttribute("data-key"), 0); return; }

    var apply = e.target.closest("[data-fl-discount-apply]");
    if (apply) {
      e.preventDefault();
      var box = apply.closest(".fl-drawer__disc"); var inp2 = box && box.querySelector("[data-fl-discount-input]");
      var msg = box && box.querySelector("[data-fl-discount-msg]");
      var code = inp2 ? inp2.value.trim() : "";
      if (!code) return;
      Cart.updateDiscount(code).then(function (res) {
        var found = (res.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (msg) {
          msg.hidden = false;
          if (found && found.applicable) { msg.className = "fl-drawer__disc-msg is-ok"; msg.textContent = (window.FLT||{}).code_ok || "CODE APPLIED"; }
          else { msg.className = "fl-drawer__disc-msg is-error"; msg.textContent = (window.FLT||{}).code_bad || "CODE NOT APPLICABLE"; Cart.updateDiscount(""); }
        }
      });
      return;
    }
  });

  /* Qty input change (typed) */
  document.addEventListener("change", function (e) {
    var inp = e.target.closest("[data-fl-qty-input]");
    if (inp) { var q = Math.max(0, parseInt(inp.value, 10) || 0); Cart.change(inp.getAttribute("data-key"), q); }
  });

  /* Product form → AJAX add.
     The add runs from the submit button's click (capture phase) and that click is cancelled, so the
     browser never fires a native "submit". Shopify's pixel manager reports product_added_to_cart for a
     product-form submit AND for the /cart/add.js call — with both, every add reached Meta (and the other
     pixels) twice, the submit copy with no product id or value. Enter in a field = synthetic click on the
     default button, so it is caught here too. Verified live 2026-10-01. */
  var PRODUCT_FORM = 'form[action*="/cart/add"], form[data-fl-product-form]';
  function addFromForm(form) {
    if (form.reportValidity && !form.reportValidity()) return Promise.resolve(null);
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return Promise.resolve(null);
    if (btn) { btn.classList.add("is-loading"); btn.disabled = true; }
    var fd = new FormData(form);
    var item = { id: fd.get("id"), quantity: parseInt(fd.get("quantity"), 10) || 1 };
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    var sp = fd.get("selling_plan"); if (sp) item.selling_plan = sp;
    return Cart.add([item]).catch(function (err) {
      alert(err.message || (window.FLT||{}).add_fail || "Could not add to cart");
    }).finally(function () { if (btn) { btn.classList.remove("is-loading"); btn.disabled = false; } });
  }
  FL.addFromForm = addFromForm;

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest('button, input[type="submit"]');
    if (!btn || btn.type !== "submit" || !btn.form || !btn.form.matches(PRODUCT_FORM)) return;
    e.preventDefault();
    addFromForm(btn.form);
  }, true);

  /* Fallback for anything that still submits a product form (e.g. requestSubmit from app code) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest(PRODUCT_FORM);
    if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { var d = drawer(); if (d && d.classList.contains("is-open")) closeDrawer(); } });
})();
